import { ReactElement } from 'react';
import { Task } from '@/api';
import {
    useTaskBeaconMarkers,
    useTaskLocations,
    useTaskUserMarker
} from '../providers';
import { TaskDetailMap } from './task-detail-map';

type TaskDetailMapPanelProps = {
    task: Task;
};

/**
 * `TaskDetailMap` wired to the task's providers. The map itself takes plain
 * props so it stays testable; this is the piece that knows where they come
 * from.
 */
export function TaskDetailMapPanel(
    props: TaskDetailMapPanelProps
): ReactElement {
    const { task } = props;

    const { locations, status } = useTaskLocations();
    const userMarker = useTaskUserMarker(task);
    const beaconMarkers = useTaskBeaconMarkers(task);

    return (
        <TaskDetailMap
            taskId={task.id}
            taskStatus={task.simpleStatus === 'COMPLETED' ? 'closed' : 'open'}
            route={locations}
            userImage={task.displayInfo.image}
            user={userMarker}
            beacons={beaconMarkers}
            status={status}
        />
    );
}
